<template>
  <svg
    data-testid="talent-avatar-female"
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3995_13264)">
      <path
        d="M0 199.833H200.167V-0.000473022H0V199.833Z"
        fill="#D3D5D2"
      />
      <path
        d="M155.035 120.074C155.035 88.57 129.496 63.0308 97.9911 63.0308C66.487 63.0308 40.9474 88.57 40.9474 120.074C40.9474 151.579 66.487 177.118 97.9911 177.118C129.496 177.118 155.035 151.579 155.035 120.074Z"
        fill="#929494"
      />
      <path
        d="M122.094 130.197C122.094 130.197 112.826 163.051 125.068 174.14C127.612 176.444 136.491 179.462 136.491 179.462L137.157 181.984C137.157 181.984 137.081 178.236 139.443 180.689C141.805 183.141 148.89 184.367 148.89 184.367L162.174 191.724C162.174 191.724 170.44 196.322 170.44 198.161C170.44 200 170.44 200 170.44 200H24.6078L38.1874 188.045L48.5196 185.593C48.5196 185.593 52.0621 181.302 53.8335 181.915C55.6045 182.528 55.6045 182.528 55.6045 182.528L58.7841 179.528C58.7841 179.528 72.3335 173.293 75.5041 168.237C81.476 158.715 78.4833 134.496 78.4833 134.496L122.094 130.197Z"
        fill="url(#paint0_linear_3995_13264)"
      />
      <path
        d="M69.0017 123.962C69.0017 123.962 64.369 131.915 84.0572 150.197C85.8188 151.832 89.7797 156.815 91.674 157.542C98.5862 160.195 102.344 158.409 106.211 157.261C109.305 156.342 113.479 151.483 113.479 151.483C113.479 151.483 129.863 138.892 130.158 132.473C130.453 126.055 132.471 123.962 132.471 123.962C132.471 123.962 132.918 123.111 134.567 123.9C137.444 125.277 139.132 119.743 139.663 113.65C140.069 108.991 137.49 103.03 134.538 103.309C131.586 103.588 132.779 104.064 132.779 104.064C132.742 103.733 133.017 98.2051 131.911 93.8896C130.233 87.3464 130.405 79.3076 123.32 75.1211C116.235 70.9349 109.605 63.4202 105.26 64.8158C100.914 66.2113 89.3711 74.2839 83.7621 72.33C78.1531 70.3766 74.436 79.9345 72.5446 83.7729C70.2221 88.4847 68.7058 104.984 69.0017 108.333C69.2972 111.682 69.2972 111.682 69.2972 111.682C69.2972 111.682 67.2307 102.751 65.4597 102.193C63.6882 101.635 60.4409 101.635 61.0315 108.333C61.6217 115.031 59.8964 110.657 64.869 122.287C67.7801 129.096 69.0017 123.962 69.0017 123.962Z"
        fill="#F1F1EF"
      />
      <path
        d="M127.713 122.266C127.713 122.266 127.793 122.595 127.876 123.156C128.118 124.805 128.375 128.452 126.639 131.59C124.313 135.795 118.946 141.279 118.946 141.279C118.946 141.279 111.253 162.121 118.946 167.606C126.639 173.091 140.058 177.479 140.058 177.479C140.058 177.479 139.521 167.606 143.1 163.95C146.678 160.293 151.509 157.185 151.509 157.185C151.509 157.185 158.129 150.238 154.729 148.775C151.33 147.313 156.697 145.301 156.697 145.301L152.94 142.559C152.94 142.559 158.665 141.279 156.697 138.537C154.729 135.795 162.422 126.654 162.422 126.654C162.422 126.654 165.822 122.449 160.097 112.759C154.371 103.069 156.518 94.2936 156.518 94.2936C156.518 94.2936 154.55 86.7977 151.867 78.205C149.183 69.6124 143.1 59.7397 137.732 55.5349C132.365 51.3299 127.445 41.823 118.856 40.7263C115.838 40.3405 110.179 41.4577 110.179 41.4577C110.179 41.4577 95.3118 34.2773 86.1147 37.7095C76.918 41.1422 62.5873 50.2332 51.1367 64.4932C39.6861 78.7536 47.0216 84.0557 47.0216 84.0557C47.0216 84.0557 44.3376 84.9695 43.2641 79.6675C43.2641 79.6675 40.4694 85.1565 43.2641 89.5402C43.2641 89.5402 28.7718 105.446 32.8869 113.673C37.002 121.9 36.6445 116.598 36.6445 116.598C36.6445 116.598 26.8208 126.105 29.4878 133.418C30.2939 135.629 28.711 137.122 29.3318 138.385C30.4159 140.591 32.3588 142.228 34.6763 142.925L37.2678 150.388C40.0159 158.302 45.7653 164.753 53.2196 168.287L72.6065 177.479C72.6065 177.479 69.9229 171.08 74.3959 163.95C78.8686 156.819 81.518 146.271 78.0547 142.089C72.2763 135.111 65.9 126.637 66.7024 118.061C67.0935 113.881 65.0339 112.192 65.1816 107.228C65.3604 101.206 68.3224 108.327 68.751 106.268C69.5539 102.411 69.8906 95.2577 71.891 93.3793C78.5106 87.1634 75.7992 91.7303 83.3416 84.9695C93.54 75.8283 85.8465 83.6899 93.54 75.8283C100.8 68.4099 108.39 64.8589 108.39 64.8589C108.39 64.8589 111.954 72.181 123.061 75.4626C129.642 77.4071 119.178 102.716 128.071 103.252C128.46 103.275 128.776 102.141 129.976 101.651C134.684 99.7287 135.426 104.281 136.028 109.518C136.419 112.923 135.791 116.371 134.218 119.4C134.197 119.441 134.176 119.482 134.154 119.523C132.867 121.984 127.521 120.702 127.713 122.266Z"
        fill="#999C9B"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3995_13264"
        x1="97.5237"
        y1="204.883"
        x2="97.5237"
        y2="120.607"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop
          offset="1"
          stop-color="#ADAFAD"
        />
      </linearGradient>
      <clipPath id="clip0_3995_13264">
        <rect
          width="200.167"
          height="200"
          rx="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'DefaultAvatarFemale'
}
</script>
